import { render, staticRenderFns } from "./DynamicDetail.vue?vue&type=template&id=09a0d118&scoped=true&"
import script from "./DynamicDetail.vue?vue&type=script&lang=js&"
export * from "./DynamicDetail.vue?vue&type=script&lang=js&"
import style0 from "./DynamicDetail.vue?vue&type=style&index=0&id=09a0d118&prod&scoped=true&lang=scss&"
import style1 from "./DynamicDetail.vue?vue&type=style&index=1&id=09a0d118&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a0d118",
  null
  
)

export default component.exports